import { Card } from '@atoms/index'
import ContactForm from '@components/ContactUs/ContactForm';

const ContactDetails = ({ onSubmit, loading, message, error, contactFormRef }) => {
    return (
        <Card
            paddingClass={`${message || error ? 'px-4 md:px-6 pt-4 md:pt-6' : 'p-4 md:p-6'} xl:p-0`}
            shadow=""
        >
            <div className="flex flex-col lg:flex-row">
                <ContactForm onSubmit={onSubmit} loading={loading} contactFormRef={contactFormRef} />
            </div>
        </Card>
    );
};

export default ContactDetails;
